<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RugAnA/tc-custom/9781453216620.jpg?1737195673427" alt="This image is the cover for the book Silicon Mage, The Windrose Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silicon Mage, The Windrose Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>A computer programmer must rescue an imprisoned wizard to save the universe in this sequel to <i>The Silent Tower</i> from the <i>New York Times</i>–bestselling author.</b><br/>  There was a time when Joanna Sheraton knew nothing of the Void. She was an ordinary computer programmer, toiling in a cubicle in air-conditioned Southern California comfort, unaware that sinister forces had penetrated her universe. But from across the interdimensional divide, an evil mage had put in motion a scheme for eternal life, by transferring himself into a computer that feeds on Earth’s life force. Called upon to help by the wizard Antryg, Joanna could do nothing more than delay. At the end of her first sojourn across the Void, Antryg was imprisoned and their task seemed hopeless. Now she must depart from Earth once more, to rescue Antryg and save humanity. She is friendless, and the dark mage’s forces hound her every step. But a good hacker is not easily deterred. <i>This ebook features an illustrated biography of Barbara Hambly, including rare photos and never-before-seen documents from the author’s personal collection.</i> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Hambly
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;Barbara Hambly (b. 1951) is a New York Times bestselling author of fantasy and science fiction, as well as historical novels set in the nineteenth century. After receiving a master's degree in medieval history, she published The Time of the Dark, the first novel in the Darwath saga, in 1982, establishing herself as an author of serious speculative fiction. Since then she has created several series, including the Windrose Chronicles, Sun-Cross, and Sun Wolf and Starhawk, in addition to writing for the Star Wars and Star Trek universes.&amp;lt;br&amp;gt;&amp;lt;br&amp;gt;Besides fantasy, Hambly has won acclaim for the James Asher vampire series, which won the Locus Award for best horror novel in 1989, and the Benjamin January mystery series, featuring a brilliant African-American surgeon in antebellum New Orleans. She lives in Los Angeles.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?636f6b73